import React from 'react'
import {ThemeProvider} from 'styled-components'
import {AppProvider, AppConsumer} from './context/AppContext'
import {BrowserRouter as Router} from 'react-router-dom'
import {CourseRouter} from './components/CourseRouter'

function App() {
  return (
    <AppProvider>
      <AppConsumer>
        {({appState}) => (
          <ThemeProvider theme={appState.currentTheme}>
            <Router>
              <CourseRouter />
            </Router>
          </ThemeProvider>
        )}
      </AppConsumer>
    </AppProvider>
  );
}

export default App;
